import Link from 'next/link';
import { useParams } from 'next/navigation';
import useTranslation from 'next-translate/useTranslation';

// Types
import type { layoutHeaderBackLinks } from '@/lib/layout/layoutHeaderBackLink';

// Components
import Icon from '@/components/base/Icon';

type BackLinksProps = {
    backLink: (typeof layoutHeaderBackLinks)[number];
};

export function BackLinks({ backLink }: BackLinksProps) {
    const { t } = useTranslation();
    const params = useParams();
    const getLink = () => {
        if ('keyParam' in backLink) {
            return backLink.redirectUrl.replace(
                `[${backLink.keyParam}]`,
                params[backLink.keyParam].toString()
            );
        }
        return backLink.redirectUrl;
    };

    return (
        <div className="flex h-8 sm:h-12">
            <Link href={getLink()} className="flex items-center gap-1.5 text-xs">
                <Icon className="text-icoGray-400 dark:text-icoDarkMode-wolf" icon="chevron-left" />
                <span>{t(backLink.text)}</span>
            </Link>
        </div>
    );
}
